<template>
  <v-card flat color="grey lighten-5">
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title> Müşteri Listesi</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="searchmusteri" label="Müşteri Ara"
          append-icon="search"></v-text-field>

 <a target="_self" v-bind:href="'#/musteri/musteriislem/id?islem=yeni'">
              <v-btn flat> <span class="hidden-sm-and-down"> Müşteri Ekle </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
            </a>
        <v-menu offset-y>
          <v-btn slot="activator" dark icon>
            <v-icon>more_vert</v-icon>
          </v-btn>

          <v-list>
            <a target="_self" v-bind:href="'#/cari/tumkayitlar/'">
              <v-list-tile>
                <v-list-tile-title>{{$t('all_records')}}</v-list-tile-title>
              </v-list-tile>
            </a>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-layout row wrap>
        <v-container fluid="">
          <v-layout row="" wrap="">
            <v-layout v-if="listeleme" row wrap>


              <v-flex xs12 sm12 md12>
                <v-layout justify-end>
                  <v-divider></v-divider>
                </v-layout>
              </v-flex>


              <v-layout row="" wrap>
                <v-flex xs12 sm12>
                  <v-card flat>
                    <v-card-title>
                      <v-spacer ></v-spacer>
                    </v-card-title>
                    <v-data-table :headers="headers" :rows-per-page-items=[50,100]   
                      :items="musteriitems" :search="searchmusteri" :loading="progress" >
                   
                      <v-progress-linear slot="progress" indeterminate ></v-progress-linear>
                      <template slot="items" slot-scope="props">
                        <td class="text-xs-left">{{ props.item.MusteriID }}</td>
                        <td class="text-xs-left">{{ props.item.Ad }}</td>
                        <td class="text-xs-left">{{ props.item.Adres }}</td>
                        <td class="text-xs-left">{{ props.item.Tel1}}</td>
                        <td class="text-xs-left">
                          <v-btn icon class="mx-0" @click="idgonder(props.item.MusteriKod)">
                        <v-icon color="red">edit</v-icon>
                        </v-btn>
                        </td>
                        
                      </template>
                      <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Aradığınız "{{ searchmusteri }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                      </v-alert>
                    </v-data-table>
                    
                  </v-card>

                  <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                    :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
                    v-model="snackbar">
                    {{ text1 }}
                    <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
                  </v-snackbar>
                </v-flex>

              </v-layout>
            </v-layout>
          </v-layout>
        </v-container>
      </v-layout>

      <template>

        <template>
          <v-card>
            <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
              :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
              v-model="snackbar">
              {{ text1 }}
              <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
            </v-snackbar>
          </v-card>
        </template>
      </template>
    </v-layout>
  </v-card>


</template>





<script>
  import auth from "@/api/auth.js"
  import _ from 'underscore'
  import router from "@/router.js"
  import helpers from "@/components/app/customcomp/helpers.js"

  export default {
    data: () => ({
      musteriitems: [],
      progress:true,
      text1: null,
      searchmusteri: null,
      detay: false,
      listeleme: true,
      active: null,
      eklebtn: false,
      kullaniciAra: null,
      yedekyetkililist: [],

      headers: [{
          text: 'Müşteri Kodu',
          value: 'MusteriID'
        },
        {
          text: 'Acente',
          value: 'Ad'
        },
        {
          text: 'Adres',
          value: 'Adres'
        },
        {
          text: 'Tel',
          value: 'Tel1'
        },
        {
          text:'Düzenle'
        }
      ],


      yetkilist: [],
      yedekresponse: [],
      bekle: false,
      AnaSirketlerWiev: [],
      AnaSirketler: [],
      Sirketler: [],
      AnaSirket: {},
      Sirket: {},
      giris: true,
      Urunler: false,
      urunlerlist: [],
      active: false,
      sektor: '0',
      uyeliktipi: '0',
      productshow: [],
      odemetipi: false,
      havale: true,
      kredikarti: false,
      odemeekrani: false,
      toplamtutar: 0,
      urunekrani: true,
      musteriid: null,
      dialogyenisirket: false,
      yenisirketunvani: null,
      sirkettipi: '0',



      dictionary: {
        custom: {
          kartno: {
            required: () => 'Bu alan boş bırakılamaz',
            min: 'Kart numarası 16 haneli olmalıdır.'
          },

          selectkarttipi: {
            required: () => 'lütfen seçiminizi yapınız',
          },
          kartcari: {
            required: () => 'lütfen seçiminizi yapınız',
          },
          selectsonkullanim: {
            required: () => 'lütfen seçiminizi yapınız',
          },
          selectsonkullanimyil: {
            required: () => 'lütfen seçiminizi yapınız',
          },

        }
      },


      clipped: true,
      drawer: true,
      fixed: false,
      miniVariant: false,
      right: true,
      rightDrawer: false,

      mevcutsirketmi: true,
      yenisirket: false,
      dialog: false,



      faturainfo: [],
      newuserstatus: false,
      loginstatus: true,
      drawer: null,
      e1: 0,
      e2: true,
      e3: true,
      e4: true,
      text1: '',
      snackbar: false,
      loading:false,
      y: 'top',
      x: 'right',
      mode: '',
      timeout: 6000,
        rules: {
        required: (value) => !!value || 'Gerekli alan.',
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Hatalı e-mail.'
        }
      },
      YeniKullanici: {
        UserID: null,
        MusteriID: 0,
        KullaniciAdi: null,
        Email: null,
        Sifre: null,
        Tip: 0,
        AdSoyad: null,
        Deleted: false,
        Aktif: false,
        MusteriBilgi: [],
        OdemeOnay: false,
      },
      unvan: null,
      confirm: null,
      Credential: {
        email: '',
        password: ''
      },
      valid: true,
      errorMsg: '',
      errorAlert: false,
      AnaSirketler: [],
      Sirketler: [],
      AnaSirket: {},
      Sirket: {}
    }),
    props: {
      source: String
    },
    methods: {
      idgonder(e){
       var url = '#/musteri/musteriislem/id?' + 'musterikod=' + e + '&islem=guncelle' 
        window.open(url, '_target')
      }
    },
    beforeMount: beforeMount,
    components: {},
    watch: {

    },
    filters: {

    },
  }

  function beforeMount() {

    var response = JSON.parse(window.localStorage.getItem('response'));

    var userparams = {
      Email: response.Email
    }

    this.$http.post(auth.API_URL + 'api/Awed/CustomerAllList', null, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.musteriitems = response.body
      this.progress= false
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-CustomerAllList'
        this.snackbar = true
        this.progress= false
      } else {
        this.text1 = 'Service Unavailable-CustomerAllList'
        this.snackbar = true
        this.progress= false
      }
    })


  }
</script>
<style scoped>

</style>